<template>
    <b-container>
        <b-card no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{
                    $t('form.create', { item: $t('miniCurriculum.languages') })
                }}</strong>
            </b-card-header>
            <b-card-body>
                <Loader :loader="loader" />
                <FormLanguage
                    v-show="!loader"
                    @onSubmit="onSubmit"
                    :language="language"
                />
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import FormLanguage from './components/FormLanguage'
import i18n from '@/i18n'
import { success, danger } from '@/lib/notification'
import api from '@/services/api'
import { getParam as getUrlParam } from '@/lib/url'
import Loader from '@/views/components/loader'
import { mapperLanguageToApi } from './mappers/mapperLanguageToApi'

export default {
    name: 'NewFormation',
    components: {
        FormLanguage,
        Loader,
    },
    data() {
        return {
            id: getUrlParam('id', this),
            language: null,
            loader: true,
        }
    },
    mounted() {
        api.get(`/languages/${this.id}/edit`)
            .then(resp => {
                const {
                    data: { data },
                } = resp

                this.language = data
            })
            .catch(e => {
                console.log(e)
                this.notificationError()
            })
            .finally(() => {
                this.loader = false
            })
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        onSubmit(form, onReset, isLoading) {
            isLoading(true)
            api.put(`/languages/${this.id}`, mapperLanguageToApi(form))
                .then(() => {
                    onReset()
                    this.notificationLanguageCreatedSuccessfully()
                    this.goBack()
                })
                .catch(e => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationLanguageCreatedSuccessfully() {
            success(
                i18n.t('notification.updatedSuccessfully', {
                    item: i18n.t('miniCurriculum.languages'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
